import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
class PaymentLinkAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "paymentlinks";

  /**
   * @override: Lấy dữ liệu danh sách
   * Created by: TMQUY 28/08/2021
   */
  getList(payload) {
    let filter = payload.filter || "";
    filter = filter.replace(filter.match(/T([0-9]{2})/g)[1], "T23");
    // URL mặc định
    let param = {
      maxResultCount: payload.take || 20,
      filter: filter || null,
      skipCount: payload.skip || 0,
      sorting: payload.Sort || null,
    };
    let url = this.getAPIUrl();
    url = this.getAPIUrl() + "/list";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }
  /**
   * Tạo payment link
   * CreatedBy: tmquy (28/08/2021)
   */
  createPaymentLink(data) {
    let url = this.getAPIUrl();
    let request = {
      url: url,
      data: data,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lấy trạng thái kích hoạt của PaymentTye theo merchant
   * CreatedBy: tmquy (18/05/2022)
   */
  getPaymentTypeActive(merchantCode, paymentType) {
    let url =
      window._apis[this.apiName] +
      `/intergrations/pmactive?merchantCode=${merchantCode}&paymentType=${paymentType}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy paymentlink theo id
   * CreatedBy: tmquy (30/08/2021)
   */
  getPaymentLinkById(id) {
    let url = this.getAPIUrl() + `/${id}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Xóa payment link
   * CreatedBy: tmquy (31/08/2021)
   */
  deletePaymentLink(id) {
    let url = this.getAPIUrl() + `?paymentlinkId=${id}`;
    let request = {
      url: url,
    };
    return httpClient.deleteAsync(request);
  }
  /**
   * Lấy hóa đơn thanh toán
   * CreatedBy: tmquy (31/08/2021)
   */
  getOrderInfor(customerCode) {
    let url = this.getAPIUrl() + "/getOrderFromEmis";
    let param = {
      BankCode: "PaymentLinks",
      Channel: 2,
      ServiceCode: "BILLING_SISAPTUITION",
      CustomerCode: customerCode,
    };
    let request = {
      url: url,
      data: param,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Tạo hóa đơn thanh toán
   * CreatedBy: tmquy (01/09/2021)
   */
  createOrderInfor(data) {
    let url = this.getAPIUrl() + "/createOrder";
    let request = {
      url: url,
      data: data,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra cáu hình payment
   * CreatedBy: tmquy (02/08/2022)
   */
  checkPaymentMethod(merchantCode) {
    let url =
      window._apis["Management"] +
      `/merchants/GetRequestConfigMethod?merchantCode=${merchantCode}&modeConfig=2&usingCache=true`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy fee
   * CreatedBy: dbhuan 21/08/2022
   */
  getFeebyMerchantCode(payload) {
    let url =
      window._apis["PaymentRequest"] +
      `/fee?MerchantCode=${payload.merchantCode}&PaymentType=${payload.paymentType}&Amount=${payload.amount}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
}

export default new PaymentLinkAPI();
